import React, {useState, useEffect} from 'react';
import {Button, Menu, MenuItem} from '@material-ui/core';
import {Language} from '@material-ui/icons';

const BlastreamTopBarLang = ({roomLang, setRoomLang}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const changeRoomLang = roomLang => {
    setAnchorEl(null);
    const roomLangUpdated = roomLang === 'fr-FR' ? 'en-US' : 'fr-FR';
    setRoomLang(roomLangUpdated);
    localStorage.setItem('roomLang', roomLangUpdated);
    window.location.reload();
  };

  useEffect(() => {
    document.documentElement.lang = roomLang;
  }, [roomLang]);

  return (
    <>
      <Button
        aria-controls="lang-menu"
        aria-haspopup="true"
        color="inherit"
        variant="outlined"
        size="small"
        onClick={e => setAnchorEl(e.currentTarget)}
        startIcon={<Language />}
      >
        {roomLang === 'fr-FR' ? 'FR' : 'EN'}
      </Button>
      <Menu
        id="lang-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        style={{zIndex: 15000, marginTop: '5px'}}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => changeRoomLang('en_US')}>fr</MenuItem>
        <MenuItem onClick={() => changeRoomLang('fr-FR')}>en</MenuItem>
      </Menu>
    </>
  );
};

export default BlastreamTopBarLang;
